import * as React from "react";

import {ResetPasswordForm} from "../components/ResetPasswordForm";
import {fullWidthViewHolder} from "./LoginView";

export const ResetPasswordView = () => {
    return (
        <div css={fullWidthViewHolder}>
            <ResetPasswordForm />
        </div>
    );
};
